@if (errorMessage) {
  <tidy-error-message [text]="errorMessage" />
}

<!-- Section header, rendered beneath the Leasing page's title + tabs. -->
@if (windowService.isDesktopRes) {
  <tidy-desktop-header [isLoading]="!loaded">
    <div class="wrappable-container">
      <tidy-text [header]="'Screenings'" />
      <form [formGroup]="searchForm" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search screenings'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search" />
      </form>
      <tidy-small-button
        [text]="'Order Screening'"
        [image]="'assets/img/add-button-white.svg'"
        (buttonClick)="orderScreening()" />
    </div>
    <div class="non-wrappable-right-aligned-container">
    </div>
  </tidy-desktop-header>
}

@if (loaded) {

  <!-- Desktop: table -->
  @if (windowService.isDesktopRes) {
    @if (shownRows.length > 0) {
      <tidy-card class="no-padding">
        <tidy-table
          #tidyTable
          [dataSource]="shownRows"
          [displayedColumns]="headers"
          [columnslabels]="headers"
          [allRowIsClickable]="true"
          [enableVirtualScrolling]="false"
          [showColumnLines]="false"
          (cellClick)="onRowClick($event)"
          [blockSorting]="true" />
      </tidy-card>
    }
    @if (shownRows.length === 0) {
      <tidy-alert><tidy-row><tidy-text [body]="'No screenings yet.'" /></tidy-row></tidy-alert>
    }
  }

  <!-- Mobile: cards -->
  @if (!windowService.isDesktopRes) {
    <div style="margin-bottom: 10px; width: 100%;">
      <form [formGroup]="searchForm" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search screenings'"
          [icon]="'assets/img/search-header.svg'"
          [fixedWidth]="false"
          class="header-search" />
      </form>
    </div>
    <tidy-row class="extra-bottom-padding">
      <tidy-button [text]="'Order Screening'" [action]="orderAction" class="primary" />
    </tidy-row>
    @for (screening of shownScreenings; track screening.id) {
      <tidy-card (click)="onRowClick({ column: '', element: { id: screening.id } })">
        <tidy-row [alignLastItemRight]="true">
          <tidy-text [header]="screening.applicant_name" [translate]="false" />
          <tidy-text [body]="screening.status" [translate]="false" [ngStyle]="{ color: statusColor(screening.status) }" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image [src]="'assets/svg/home-outline.svg'" class="body-size" />
          <tidy-text [helper]="screening.property_name + '  ·  ' + screening.memberLabel" [translate]="false" />
        </tidy-row>
        <tidy-row [alignLastItemRight]="true">
          <tidy-text [body]="screening.credit_score !== null ? ('Credit ' + screening.credit_score) : 'Awaiting results'" [translate]="false" />
          <tidy-text [body]="recommendationLabel(screening.recommendation)" [translate]="false" [ngStyle]="{ color: recommendationColor(screening.recommendation) }" />
        </tidy-row>
      </tidy-card>
    }
    @if (shownScreenings.length === 0) {
      <tidy-alert><tidy-row><tidy-text [body]="'No screenings yet.'" /></tidy-row></tidy-alert>
    }
  }
}
